




























































































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Prop, Component } from 'vue-property-decorator';
import { SwActionBar, SwActionBarItem } from '@libs-uuif/shared/sw-action-bar';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import {
  SwModal,
  SwModalBody,
  SwModalFooter,
} from '@libs-uuif/shared/sw-modal';
const cssPrefix = 'swCaptchaDialog';
@Component({
  components:{
    SwActionBar,
    SwActionBarItem,
    SwButton,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwTextfield,
  },
})
export default class SwCaptchaDialog extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop()
  data: any;
  @Prop()
  isShowModal: boolean;
  customCaptchaInput: string = '';
  captchaImg: string = '';
  customCaptchaCode: string = '';
  customCaptchaError: boolean = false;
  mounted() {
    this.captchaImg =  this.data.captchBaseString ? this.data.captchBaseString : '';
    this.customCaptchaCode = this.data.captchDetail ? this.data.captchDetail.split('%5e')[1] : '';
    if (this.$refs['captchaTextField']) {
      (this.$refs['captchaTextField'] as SwTextfield).focus();
    }
  }
  private closeDialog() {
    this.customCaptchaError = false;
    this.customCaptchaInput = '';
    this.$emit('closeEvent');
  }
  private verifyCaptcha() {
    if (this.customCaptchaInput === '') {
      this.customCaptchaError = true;
      return;
    }
    const captcha = `CH^${this.customCaptchaInput}^${this.customCaptchaCode}`;
    this.customCaptchaInput = '';
    this.$emit('closeEvent', captcha);
  }
}
